import { isBefore } from 'date-fns'

export type NewFeature = 'insurance'

// Último dia em que o selo "Novo" do recurso aparece na navegação.
const NEW_FEATURE_DEADLINE: Record<NewFeature, string> = {
  insurance: '2026-10-02',
}

export const isNewFeature = (feature: NewFeature) =>
  isBefore(new Date(), new Date(`${NEW_FEATURE_DEADLINE[feature]}T23:59:59`))
